export default "__VITE_ASSET__BZ4M1k2j__"